export interface FeatureToggleState {
  name: string;
  enabled: boolean;
}

export const isSeasonFeatureEnabled = (
  featureToggles: FeatureToggleState[],
  name: string
) => featureToggles.some((toggle) => toggle.name === name && toggle.enabled === true);

export const shouldRedirectDisabledFeatureTab = (
  featureTogglesLoaded: boolean,
  featureEnabled: boolean
) => featureTogglesLoaded && !featureEnabled;

export const setFeatureToggleEnabled = <T extends FeatureToggleState>(
  featureToggles: T[],
  name: string,
  enabled: boolean
) => featureToggles.map((toggle) => (
  toggle.name === name ? { ...toggle, enabled } : toggle
));

export const validateSeasonDates = (startDate: string, endDate: string) => {
  if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
    return { endDate: 'End date must be after start date' };
  }

  return {};
};

export const SEASON_LOCATION_PATTERN = /^[a-zA-Z\s,'/-]+$/;
export const SEASON_LOCATION_INPUT_PATTERN = /^[a-zA-Z\s,'/-]*$/;
export const SEASON_LOCATION_ERROR_MESSAGE =
  'Location can only contain letters, spaces, commas, hyphens, slashes, and apostrophes';

export const normalizeEventCategories = (value: string) =>
  value
    .split(',')
    .map((category) => category.trim())
    .filter(Boolean);

type TvPassConfigFormValues = {
  matchEnabled: boolean;
  matchPrice: string;
  seasonEnabled: boolean;
  seasonPrice: string;
  tournamentEnabled: boolean;
};

const buildTvPassOption = (enabled: boolean, price: string) => ({
  enabled,
  ...(enabled && price
    ? { pricing: { IN: { amount: Number(price), currency: 'INR' as const } } }
    : {}),
});

export const buildTvPassConfig = ({
  matchEnabled,
  matchPrice,
  seasonEnabled,
  seasonPrice,
  tournamentEnabled,
}: TvPassConfigFormValues) => ({
  match: buildTvPassOption(matchEnabled, matchPrice),
  season: buildTvPassOption(seasonEnabled, seasonPrice),
  tournament: { enabled: tournamentEnabled },
});
